<template>
  <div class="air__utils__scrollTable mb-4">
    <a-table
      :rowKey="record => record.topic_name"
      :columns="columns"
      :dataSource="data"
      :pagination="false"
      :scroll="{ x: 'max-content' }"
      :loading="loading"
    >
      <!-- Progress Bar -->
      <template slot="avg_progress" slot-scope="avg_progress">
        <a-progress
          :percent="avg_progress"
          :strokeColor="getProgressColor(avg_progress)"
          size="small"
          :status="avg_progress === 100 ? 'success' : 'active'"
          :format="() => `${avg_progress}%`"
        />
      </template>

      <!-- Completed Sections Names -->
      <template slot="completed_section_names" slot-scope="completed_section_names">
        <span class="font-weight-bold">{{ completed_section_names || 'None' }}</span>
      </template>
    </a-table>
  </div>
</template>

<script>
const columns = [
  {
    title: 'Topic Name',
    dataIndex: 'topic_name',
    key: 'topic_name',
    width: 120,
    sorter: true,
    className: 'text-left',
  },
  {
    title: 'Academic Term',
    dataIndex: 'academic_term',
    key: 'academic_term',
    width: 100,
    sorter: true,
    className: 'text-center',
  },
  {
    title: 'Avg. Progress (All Sections)',
    dataIndex: 'avg_progress',
    key: 'avg_progress',
    width: 100,
    scopedSlots: { customRender: 'avg_progress' },
    sorter: true,
    className: 'text-center',
  },
  {
    title: 'Completed Sections',
    dataIndex: 'completed_section_names',
    key: 'completed_section_names',
    width: 200,
    scopedSlots: { customRender: 'completed_section_names' },
    className: 'text-center',
  },
]

export default {
  name: 'ProgressByTopicTable',
  props: {
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns,
    }
  },
  methods: {
    // same color logic as overview table
    getProgressColor(progress) {
      if (progress < 30) return '#ff4d4f' // red
      if (progress < 70) return '#faad14' // orange
      return '#52c41a' // green
    },
  },
}
</script>

<style scoped>
.text-danger {
  color: #ff4d4f;
}
.font-weight-bold {
  font-weight: 600;
}
</style>
